/* ============================================================
   V2 PDP  ·  Jolie Co
   ------------------------------------------------------------
   Loaded only by sections/v2-main-product.liquid.

   IMPORTANT: this file must never replace Dawn's variant or
   cart behaviour. product-info.js owns variant changes and
   product-form.js owns add-to-cart, and both are shared with
   every product on the store. We only listen and decorate.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('.v2-pdp');
  if (!root) return;

  /* Dawn dispatches this on the <product-info> element whenever
     the selected variant changes. Everything reactive in the new
     buy box hangs off it — the checklist, the price highlight,
     the 01/02 header summaries. */
  var info = root.querySelector('product-info');
  if (info) {
    info.addEventListener('variant:change', function (event) {
      // event.detail.variant — wire the checklist and summaries here
      void event;
    });
  }

  /* Accordions, chips and the charm rail are self-contained and
     safe to handle here — they touch nothing Dawn relies on. */

  root.addEventListener('click', function (event) {
    var acc = event.target.closest('.v2-acc__head');
    if (acc && acc.parentElement) {
      acc.parentElement.classList.toggle('is-open');
      return;
    }
  });
})();